export const MBD_TYPE = {
  SEARCH_BUTTON: 'SEARCH_BUTTON',
  HOTEL_SORT_BY: 'HOTEL_SORT_BY',
  HOTEL_INVENTORY_IMAGES: 'HOTEL_INVENTORY_IMAGES',
  HOTEL_INVENTORY_PRIMARY: 'HOTEL_INVENTORY_PRIMARY',
  HOTEL_INVENTORY_SECONDARY: 'HOTEL_INVENTORY_SECONDARY',
  HOTEL_SAVE_CTA: 'HOTEL_SAVE_CTA',
  HOTEL_SAVE_SUCCESS: 'HOTEL_SAVE_SUCCESS',
  SEARCH_FILTER_PRICE: 'SEARCH_FILTER_PRICE',
  SEARCH_FILTER_POI: 'SEARCH_FILTER_POI',
  SEARCH_FILTER_CONFIDENT_TYPE: 'SEARCH_FILTER_CONFIDENT_TYPE',
  SEARCH_FILTER_STAR_RATING: 'SEARCH_FILTER_STAR_RATING',
  SEARCH_FILTER_GUEST_RATING: 'SEARCH_FILTER_GUEST_RATING',
  SEARCH_FILTER_PROPERTY_TYPE: 'SEARCH_FILTER_PROPERTY_TYPE',
  SEARCH_FILTER_DISTRICT: 'SEARCH_FILTER_DISTRICT',
  SEARCH_FILTER_CANCELLATION: 'SEARCH_FILTER_CANCELLATION',
  SEARCH_FILTER_MEAL_PLAN: 'SEARCH_FILTER_MEAL_PLAN',
  SEARCH_FILTER_DISCOUNT_TYPES: 'SEARCH_FILTER_DISCOUNT_TYPES',
  SEARCH_FILTER_AMENITIES: 'SEARCH_FILTER_AMENITIES',
  SEARCH_FILTER_GUEST_TYPE: 'SEARCH_FILTER_GUEST_TYPE',
  SEARCH_FILTER_CHAIN: 'SEARCH_FILTER_CHAIN',
  SEARCH_FILTER_SORT_TYPE: 'SEARCH_FILTER_SORT_TYPE',
  SEARCH_FILTER_PARTNERS: 'SEARCH_FILTER_PARTNERS',
  HOTEL_DETAILS_MAP: 'HOTEL_DETAILS_MAP',
  HOTEL_DETAILS_IMAGE_GALLERY: 'HOTEL_DETAILS_IMAGE_GALLERY',
  SEARCH_MAP: 'SEARCH_MAP',
  HOTEL_OFFER_FILTERS: 'HOTEL_OFFER_FILTERS',
  HOTEL_SORT_BY_POI_LIST: 'HOTEL_SORT_BY_POI_LIST',
  NEIGHBOURHOOD_CHIP_ON_MAP: 'NEIGHBOURHOOD_CHIP_ON_MAP',
  NEIGHBOURHOOD_CHIP_INLINE: 'NEIGHBOURHOOD_CHIP_INLINE',
  NEIGHBOURHOOD_MAP_MARKER: 'NEIGHBOURHOOD_MAP_MARKER',
  HOTEL_REWARD_PRICE: 'HOTEL_REWARD_PRICE',
  ROOM_TYPES: 'ROOM_TYPES',
  VIBES: 'VIBES',
  COPY_PASTE_URL_SUBMIT: 'COPY_PASTE_URL_SUBMIT',
  COPY_PASTE_CHEAPER_OUTCOME: 'COPY_PASTE_CHEAPER_OUTCOME',
} as const;

export type MbdType = (typeof MBD_TYPE)[keyof typeof MBD_TYPE];

export const MBD_ITEMS = {
  [MBD_TYPE.SEARCH_BUTTON]: {
    id: 'search_control_search_button',
    name: 'search_control_search_button',
  },
  [MBD_TYPE.HOTEL_INVENTORY_IMAGES]: {
    id: 'hotel_inventory_images_cta',
    name: 'hotel_inventory_images_cta',
  },
  [MBD_TYPE.HOTEL_INVENTORY_PRIMARY]: {
    id: 'hotel_inventory_primary_cta',
    name: 'hotel_inventory_primary_cta',
  },
  [MBD_TYPE.HOTEL_INVENTORY_SECONDARY]: {
    id: 'hotel_inventory_secondary_cta',
    name: 'hotel_inventory_secondary_cta',
  },
  [MBD_TYPE.HOTEL_SORT_BY]: {
    id: 'hotel_sort_by',
    name: 'hotel_sort_by',
  },
  [MBD_TYPE.HOTEL_SAVE_CTA]: {
    id: 'hotel_save_cta',
    name: 'hotel_save_cta',
  },
  [MBD_TYPE.HOTEL_SAVE_SUCCESS]: {
    id: 'hotel_save_success',
    name: 'hotel_save_success',
  },
  [MBD_TYPE.SEARCH_FILTER_PRICE]: {
    id: 'hotels_filter_price',
    name: 'hotels_filter_price',
  },
  [MBD_TYPE.SEARCH_FILTER_CONFIDENT_TYPE]: {
    id: 'hotels_filter_confident',
    name: 'hotels_filter_confident',
  },
  [MBD_TYPE.SEARCH_FILTER_POI]: {
    id: 'hotels_filter_poi',
    name: 'hotels_filter_poi',
  },
  [MBD_TYPE.SEARCH_FILTER_STAR_RATING]: {
    id: 'hotels_filter_star_rating',
    name: 'hotels_filter_star_rating',
  },
  [MBD_TYPE.SEARCH_FILTER_GUEST_RATING]: {
    id: 'hotels_filter_guest_rating',
    name: 'hotels_filter_guest_rating',
  },
  [MBD_TYPE.SEARCH_FILTER_PROPERTY_TYPE]: {
    id: 'hotels_filter_property_type',
    name: 'hotels_filter_property_type',
  },
  [MBD_TYPE.SEARCH_FILTER_DISTRICT]: {
    id: 'hotels_filter_district',
    name: 'hotels_filter_district',
  },
  [MBD_TYPE.SEARCH_FILTER_CANCELLATION]: {
    id: 'hotels_filter_cancellation',
    name: 'hotels_filter_cancellation',
  },
  [MBD_TYPE.SEARCH_FILTER_MEAL_PLAN]: {
    id: 'hotels_filter_meal_plan',
    name: 'hotels_filter_meal_plan',
  },
  [MBD_TYPE.SEARCH_FILTER_DISCOUNT_TYPES]: {
    id: 'hotels_filter_discount_types',
    name: 'hotels_filter_discount_types',
  },
  [MBD_TYPE.SEARCH_FILTER_AMENITIES]: {
    id: 'hotels_filter_amenities',
    name: 'hotels_filter_amenities',
  },
  [MBD_TYPE.SEARCH_FILTER_GUEST_TYPE]: {
    id: 'hotels_filter_guest_type',
    name: 'hotels_filter_guest_type',
  },
  [MBD_TYPE.SEARCH_FILTER_CHAIN]: {
    id: 'hotels_filter_chain',
    name: 'hotels_filter_chain',
  },
  [MBD_TYPE.SEARCH_FILTER_SORT_TYPE]: {
    id: 'hotels_filter_sort_type',
    name: 'hotels_filter_sort_type',
  },
  [MBD_TYPE.HOTEL_DETAILS_MAP]: {
    id: 'hotel_details_map',
    name: 'hotel_details_map',
  },
  [MBD_TYPE.HOTEL_DETAILS_IMAGE_GALLERY]: {
    id: 'image_gallery_enabled',
    name: 'image_gallery_enabled',
  },
  [MBD_TYPE.SEARCH_MAP]: {
    id: 'search_map_cta',
    name: 'search_map_cta',
  },
  [MBD_TYPE.HOTEL_OFFER_FILTERS]: {
    id: 'hotel_offer_filters',
    name: 'hotel_offer_filters',
  },
  [MBD_TYPE.SEARCH_FILTER_PARTNERS]: {
    id: 'hotels_filter_partners',
    name: 'hotels_filter_partners',
  },
  [MBD_TYPE.HOTEL_SORT_BY_POI_LIST]: {
    id: 'hotel_sort_by_poi_list',
    name: 'hotel_sort_by_poi_list',
  },
  [MBD_TYPE.NEIGHBOURHOOD_CHIP_ON_MAP]: {
    id: 'neighbourhood_chip_on_map',
    name: 'neighbourhood_chip_on_map',
  },
  [MBD_TYPE.NEIGHBOURHOOD_CHIP_INLINE]: {
    id: 'neighbourhood_chip_inline',
    name: 'neighbourhood_chip_inline',
  },
  [MBD_TYPE.HOTEL_REWARD_PRICE]: {
    id: 'hotel_reward_price',
    name: 'hotel_reward_price',
  },
  [MBD_TYPE.NEIGHBOURHOOD_MAP_MARKER]: {
    id: 'neighbourhood_map_marker',
    name: 'neighbourhood_map_marker',
  },
  [MBD_TYPE.ROOM_TYPES]: {
    id: 'hotels_filter_room_types',
    name: 'hotels_filter_room_types',
  },
  [MBD_TYPE.VIBES]: {
    id: 'hotels_filter_vibes',
    name: 'hotels_filter_vibes',
  },
  [MBD_TYPE.COPY_PASTE_URL_SUBMIT]: {
    id: 'copy_paste_url_submit',
    name: 'copy_paste_url_submit',
  },
  [MBD_TYPE.COPY_PASTE_CHEAPER_OUTCOME]: {
    id: 'copy_paste_cheaper_outcome',
    name: 'copy_paste_cheaper_outcome',
  },
};

export const IDS = Object.fromEntries(
  Object.entries(MBD_ITEMS).map(([key, value]) => [key, value.id]),
) as Record<keyof typeof MBD_ITEMS, string>;

export const NAMES = Object.fromEntries(
  Object.entries(MBD_ITEMS).map(([key, value]) => [key, value.name]),
) as Record<keyof typeof MBD_ITEMS, string>;
